import { createSlice } from "@reduxjs/toolkit";
import { IClient } from "../../Typings/Client";

export const SelectedClientSlice = createSlice({
  name: "selectedClient",
  initialState: {
    value: {} as IClient,
  },
  reducers: {
    updateClient: (state, action) => {
      state.value = action.payload;
    },
    removeClient: (state) => {
      state.value = {} as IClient;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateClient, removeClient } = SelectedClientSlice.actions;

export const selectClientValue = (state: any) =>
  state.selectedClient.value as IClient;

export default SelectedClientSlice.reducer;
